import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Starfield } from "./Starfield";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-cg-bg flex items-center justify-center">
        <Starfield count={40} />
        <div className="relative z-10 h-10 w-10 rounded-full border-2 border-cg-violet border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user || !user.user_id) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
